import ReactDOM from "react-dom/client";
import React, { useEffect, useRef } from "react";
import Cookies from "js-cookie";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ToastProvider } from "./components_root/ToastContext";

function IndexWrapper() {
  const effectRan = useRef(false);

  // ✅ Correct root-domain detection (supports .co.in)
  const getRootDomain = () => {
    const hostname = window.location.hostname;

    if (hostname === "localhost" || /^[0-9.]+$/.test(hostname)) {
      return undefined;
    }

    const parts = hostname.split(".");
    const commonSLDs = ["co", "com", "net", "org", "gov", "edu", "in"];

    if (parts.length > 2 && commonSLDs.includes(parts[parts.length - 2])) {
      return "." + parts.slice(-3).join(".");
    }

    return "." + parts.slice(-2).join(".");
  };

  useEffect(() => {
    // 🚫 Prevent double run in React.StrictMode
    if (effectRan.current) return;
    effectRan.current = true;

    let watchId;

    const cookieOptions = {
      expires: 1,
      path: "/",
      sameSite: "Lax",
      secure: window.location.protocol === "https:",
      ...(getRootDomain() && { domain: getRootDomain() })
    };

    // 🌍 IP-based location
    const fetchIPLocation = async () => {
      try {
        const res = await fetch("https://ipapi.co/json/");
        const data = await res.json();

        Cookies.set("ipaddress", data.ip || "no", cookieOptions);
        Cookies.set("country", data.country_name || "no", cookieOptions);
        Cookies.set("city", data.city || "no", cookieOptions);
        Cookies.set("state", data.region || "no", cookieOptions);
        Cookies.set("postcode", data.postal || "no", cookieOptions);

        console.log("✅ IP cookies set:", Cookies.get("country"));
      } catch (err) {
        console.error("❌ IP location error:", err);
      }
    };

    // 📡 Live GPS (permission required)
    const startLiveLocation = () => {
      if (!navigator.geolocation) return;

      watchId = navigator.geolocation.watchPosition(
        (position) => {
          Cookies.set("latitude", String(position.coords.latitude), {
            expires: 365,
            path: "/",
            sameSite: "Lax",
            secure: window.location.protocol === "https:"
          });

          Cookies.set("longitude", String(position.coords.longitude), {
            expires: 365,
            path: "/",
            sameSite: "Lax",
            secure: window.location.protocol === "https:"
          });

          console.log("📡 GPS cookies updated");
        },
        (error) => {
          console.warn("⚠️ GPS permission denied");
        },
        { enableHighAccuracy: true }
      );
    };

    fetchIPLocation();
    startLiveLocation();

    return () => {
      if (watchId) navigator.geolocation.clearWatch(watchId);
    };
  }, []);

  return (
    <BrowserRouter>
      <ToastProvider>
        <App />
      </ToastProvider>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <IndexWrapper />
  </React.StrictMode>
);

reportWebVitals();
